/**
 *
 * Subscriptions
 *
 */
import React, { memo } from 'react';
import { Stats } from './components/stats';
import { RecentUsersTable } from './components/recent-users-table';
import { RecentOrdersTable } from './components/recent-orders';
import { RecentRequestFiles } from './components/recent-request-files';
import { RecentEnquiry } from './components/recent-enquiry';
import { RecentTransactions } from './components/recent-transactions';
import { TopFileDownloads } from './components/top-file-downloads';
import { RecentDownloads } from './components/recent-downloads';
import { RecentWalletTransactions } from './components/recent-wallet-transactions';

interface Props {}

export const DashboardOverview = memo((props: Props) => {
  return (
    <div>
      <Stats />
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-6">
          <RecentUsersTable />
        </div>
        <div className="col-span-6">
          <RecentOrdersTable />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-6">
          <RecentTransactions />
        </div>
        <div className="col-span-6">
          <RecentWalletTransactions />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-6">
          <RecentRequestFiles />
        </div>
        <div className="col-span-6">
          <RecentEnquiry />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 mt-5">
        <div className="col-span-6">
          <TopFileDownloads />
        </div>
        <div className="col-span-6">
          <RecentDownloads />
        </div>
      </div>
    </div>
  );
});
